import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function FailedSolutions() {
  const failures = ['Las infusiones y remedios naturales se quedan cortos cuando el ataque ya ha comenzado.', 'Los fármacos a menudo te dejan sedada, pero no te enseñan cómo recuperar el control por ti misma.', 'Los consejos de "solo relájate" son inútiles porque no puedes razonar con un cerebro que está en modo supervivencia.', 'Ignorar el problema solo hace que el cortisol se acumule, provocando explosiones de angustia cada vez más frecuentes.'];
  return <section className="w-full py-24 px-4 bg-brand-cream" data-id="element-20">
      <div className="max-w-4xl mx-auto" data-id="element-21">
        <div className="text-center mb-16" data-id="element-22">
          <span className="text-brand-purple font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-23">
            Lo que ya intentaste
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-slate" data-id="element-24">
            ¿Por qué nada ha funcionado hasta ahora?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-25">
          {failures.map((text, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-brand-creamDark flex items-start space-x-4" data-id="element-26">
              <XCircleIcon className="w-6 h-6 text-brand-coral flex-shrink-0 mt-1" aria-hidden="true" data-id="element-27" />
              <p className="text-brand-navy text-lg leading-relaxed" data-id="element-28">{text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}